import { render, staticRenderFns } from "./example.vue?vue&type=template&id=b91290aa&scoped=true&"
import script from "./example.vue?vue&type=script&lang=ts&"
export * from "./example.vue?vue&type=script&lang=ts&"
import style0 from "./example.vue?vue&type=style&index=0&id=b91290aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91290aa",
  null
  
)

export default component.exports